import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

import { useGmsAccess } from '@/features/gms';

interface GuideReaderRouteProps {
  children: ReactNode;
}

/**
 * Route guard for the guide reader at `/guides/:toolKey/:topicKey`.
 *
 * Readers need `gms:read` — the pilot group — not `gms:author`, which is the difference
 * from `GuidanceRoute`. A shared link opened by someone outside the rollout lands on
 * /home, the same outcome the other limited-rollout routes give.
 *
 * The backend enforces the same gate on every endpoint independently. This guard only
 * decides whether to render; hiding a page is not authorization.
 */
export function GuideReaderRoute({ children }: GuideReaderRouteProps) {
  const { data, isLoading, isError } = useGmsAccess();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (isError || !data?.gms_enabled || !data?.can_view) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
